module.exports = __webpack_public_path__ + "img/15.75b6b5ec.png";